import type { Ref } from 'vue';

import type { ClientResourceContainer } from '@/features/Clients';
import type { FeaturesStoreState } from '@/features/Features/store';
import type { TariffStoreState } from '@/features/Tariffs/store';

export interface UseLocalStorage {
  checkStorageIsAvailable: () => void;
  isLocalStorageAvailable: Ref<boolean>;

  safeState: () => void;
  loadState: () => void;
  removeItem: (key: string) => void;
  hasStoredState: (sparte: string) => boolean;
  safeTransferableState: () => void;
  loadTransferableState: () => void;
}

export interface LocalStorageState {
  state: {
    clients: ClientResourceContainer[];
    input: Record<string, unknown>;
    tariffs: TariffStoreState;
    features: FeaturesStoreState;
    // @todo save contractStore
  };
  version: number;
}

export const isLocalStorageState = (data: unknown): data is LocalStorageState =>
  Object.prototype.hasOwnProperty.call(data, 'state') &&
  Object.prototype.hasOwnProperty.call(
    (data as LocalStorageState)?.state,
    'clients',
  ) &&
  Object.prototype.hasOwnProperty.call(
    (data as LocalStorageState)?.state,
    'input',
  ) &&
  Object.prototype.hasOwnProperty.call(
    (data as LocalStorageState)?.state,
    'tariffs',
  ) &&
  Object.prototype.hasOwnProperty.call(
    (data as LocalStorageState)?.state,
    'features',
  );
